import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-203b4fdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar" }

import ThemeButton from '@/components/Navbar/ThemeButton.vue';
import LanguageButtons from '@/components/Navbar/LanguageButtons.vue';
import Navigation from '@/components/Navbar/Navigation.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Navigation)
  ]))
}
}

})